/* eslint-disable max-len */
'use strict';

angular.module('webAgro1App').factory('RotateImageService', function($http, $q, UtilsService) {
  return {
    rotate: function(imagem, direction) {
      const deferred = $q.defer();
      const params = {
        id: imagem.idOriginal,
        direction: direction
      };

      $http.patch(`${SERVER + API_VERSION}imagens/${params.id}/rotate?direction=${params.direction}`).then(function(result) {
        const rotatedImage = result.data;
        imagem.report = UtilsService.getUrl(rotatedImage.imagem_report_url);
        imagem.thumb = UtilsService.getUrl(rotatedImage.imagem_thumb_url);
        imagem.url = UtilsService.getUrl(rotatedImage.imagem_url);
        imagem.processing = false;
        deferred.resolve(imagem);
      }, deferred.reject);

      return deferred.promise;
    }
  };
});
